import React, {memo, useState, ReactNode, useCallback, useEffect} from "react"
import {Column} from "../../Column"
import {ControlModel, ControlTypeModel} from "../../../types/control"
import {useDebounce} from "../../../hooks/debounce"
import {useRPC} from "../../../hooks/rpc"
import {RgbColor} from "../../ColorPicker/types"
import {RGBColorPickerComponent} from "./components"
import {useMessage} from "../../../hooks/message"

type Props = {
    control: ControlModel
    controlType: ControlTypeModel
    children?: ReactNode
}

export const RGBPicker = memo(function RGBPicker(props: Props) {
    const {control, children, controlType} = props
    const [color, setColor] = useState({
        r: control.parameters["r"],
        g: control.parameters["g"],
        b: control.parameters["b"]
    })
    const [value, setValue] = useState<number>(control.current_value)
    const [rpc] = useRPC()
    const {failure} = useMessage()

    const handleChange = useDebounce((selectedColor: RgbColor) => {
        setColor(selectedColor)
        rpc.updateRGBControlValue(control.id, value, selectedColor).catch(failure)
    }, 600)

    const onChange = useCallback(
        (value: number) => {
            setColor(color)
            setValue(value)
            rpc.updateRGBControlValue(control.id, value, color)
        },
        [rpc, color, control.id]
    )

    useEffect(() => {
        if (control?.parameters["r"] === 99 && control?.parameters["g"] === 99 && control?.parameters["b"] === 99) {
            setColor({
                r: 255,
                g: 0,
                b: 0
            })
        } else {
            setColor({
                r: control.parameters["r"],
                g: control.parameters["g"],
                b: control.parameters["b"]
            })
        }
    }, [control])


    return (
        <Column min={6} max={12}>
            <RGBColorPickerComponent
                color={color}
                name={control.name}
                value={control.current_value}
                onChange={onChange}
                onChangeColor={handleChange}
                activeImage={controlType.image_set.active}
                passiveImage={controlType.image_set.passive}
            >
                {children}
            </RGBColorPickerComponent>
        </Column>
    )
})
